import { LegalPage } from "../components/LegalPage";
import { SEO } from "../lib/seo";

export const PrivacyPolicyPage = () => (
  <>
    <SEO
      title="Privacy Policy"
      description="How Humaniti collects, uses, and protects your data. Your rights under GDPR, CCPA, and DPDP."
      path="/privacy"
    />
    <LegalPage
      title="Privacy Policy"
      effectiveDate="2026-04-23"
      intro={
        <p>
          This Privacy Policy explains what data Humaniti collects when you use our services, why we
          collect it, how long we keep it, and your rights.
        </p>
      }
      sections={[
        {
          id: "what",
          title: "1. What we collect",
          body: (
            <p>
              Account identifiers (email, phone, wallet pubkey), KYC verifications (status only, not
              raw documents), session metadata, audit events. Payment information for requesters;
              payout records for annotators.
            </p>
          ),
        },
        {
          id: "why",
          title: "2. Why we collect it",
          body: (
            <p>
              To operate the platform, verify identities, process payments, prevent fraud, and meet
              legal obligations.
            </p>
          ),
        },
        {
          id: "lawful",
          title: "3. Lawful basis",
          body: (
            <p>
              Contract performance for service provision; legitimate interest for fraud prevention;
              legal obligation for KYC and tax records; consent for marketing emails.
            </p>
          ),
        },
        {
          id: "retention",
          title: "4. Retention",
          body: (
            <p>
              User account data: 30 days after account deletion request, then permanent erasure.
              Audit events: 2 years. Financial records: 7 years (tax law).
            </p>
          ),
        },
        {
          id: "rights",
          title: "5. Your rights",
          body: (
            <p>
              Export your data via <code>/privacy</code> after sign-in. Delete your account (30-day
              soft-delete). Update your profile via <code>/profile</code>. Contact us at
              privacy@humaniti.io for any other request.
            </p>
          ),
        },
        {
          id: "contact",
          title: "6. Contact",
          body: <p>privacy@humaniti.io</p>,
        },
      ]}
    />
  </>
);
